/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { userDetail } from './test-data/user.detail';

const is = require("is_js");

const { LoggerModule } = require("@vlinder-web/logger-module-react");
const SERVICE_NAME = "userDetail.service";
const log: any = LoggerModule.getInstance();

export class UserDetailService {
    name = SERVICE_NAME;
    private static instance: UserDetailService;
    private constructor() {
        this.report();
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new UserDetailService();
        }
        return this.instance;
    }
    async init() {}

    

    async getUserData() {
        let _userData = userDetail;
        return _userData;
    }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, "Module Report");
        log?.info(SERVICE_NAME, "⦿ Name: " + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
